import type { PropsWithChildren } from "react";

export function Card({ children, className = "" }: PropsWithChildren<{ className?: string }>) {
  return (
    <section
      className={`rounded-card border border-line bg-gradient-to-b from-bg2 to-bg1 p-[18px_16px] shadow-card mb-3 ${className}`}
    >
      {children}
    </section>
  );
}
